exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".edit_wrap[data-v-1f50f9b8]{width:1050px;margin:50px auto;border:1px solid #eee}.edit_wrap .edit_tab[data-v-1f50f9b8]{display:inline-block;width:20%;height:46px;text-align:center;line-height:46px;color:#fff;background:#ff6c83}.edit_wrap .active_tab[data-v-1f50f9b8]{background:#ff4a7d}.edit_wrap .tip_word[data-v-1f50f9b8]{margin-top:20px;width:1048px;height:88px;background:#f9f9f9;padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-1f50f9b8","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/supplierInfo/suppliercommonPages.vue
// module id = 353
// module chunks = 0